import ComponentLoader from 'components/ComponentLoader'
import isDesktopFromWebpackOrFromSSRUtil from 'modules/viewport/utils/is-desktop-screen-from-webpack-or-from-ssr'
import PropTypes from 'prop-types'
import React from 'react'
import { useTheme } from 'modules/styles/index.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import shouldHideHeaderRouterSelect from 'modules/router/selectors/should-hide-header/index.js'

function loadDesktopHeader () {
  return import(/* webpackChunkName: "containers/Header/Desktop" */ 'containers/Header/Desktop')
}

function loadMobileHeader () {
  return import(/* webpackChunkName: "containers/Header/Mobile" */ 'containers/Header/Mobile')
}

function HeaderMobileWrapper ({
  isSmallScreen,
  ...props
}) {
  if (SMALL_SCREEN || (SERVER && global.SMALL_SCREEN)) {
    if (!isSmallScreen) {
      return (
        <ComponentLoader
          loadComponent={loadDesktopHeader}
          shouldNotShowLoader
          {...props}
        />
      )
    }

    const HeaderMobile = require('containers/Header/Mobile').default
    return (
      <HeaderMobile
        {...props}
      />
    )
  }
  return <></>
}

function HeaderDesktopWrapper ({
  isSmallScreen,
  ...props
}) {
  if (isDesktopFromWebpackOrFromSSRUtil()) {
    if (isSmallScreen) {
      return (
        <ComponentLoader
          loadComponent={loadMobileHeader}
          shouldNotShowLoader
          {...props}
        />
      )
    }

    const HeaderDesktop = require('containers/Header/Desktop').default
    return (
      <HeaderDesktop
        {...props}
      />
    )
  }
  return <></>
}

export default function Header ({
  isSmallScreen,
  ...rest
}) {
  const theme = useTheme()
  const shouldHideHeader = useSelector(shouldHideHeaderRouterSelect)
  if (shouldHideHeader) {
    return <></>
  }

  return (
    <header
      style={{
        width: '100%',
        height: isSmallScreen ? '2.77em' : '4.44em',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: '0',
        transition: 'transform 0.200s linear',
        zIndex: theme.zIndex.header,
        backgroundColor: '#ffffff',
        color: '#666666',
        borderBottom: '0.055em solid  #e6e6e6'
      }}
    >
      <HeaderDesktopWrapper
        isSmallScreen={isSmallScreen}
        {...rest}
      />

      <HeaderMobileWrapper
        isSmallScreen={isSmallScreen}
        {...rest}
      />
    </header>
  )
}

Header.propTypes = {
  location: PropTypes.object.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isSmallScreen: PropTypes.bool,
  match: PropTypes.object,
  route: PropTypes.object.isRequired
}
